import React from 'react';
import { Box } from '@mui/material';
import { StyledHeader, StyledParagraph } from './typographyblock.styles';
import {
  typographyBlockPropTypes,
  typographyBlockDefaultProps,
} from './typographyblock.propTypes';

/**
 * Component to render a block with header and paragraph Typography components.
 *
 * @component
 * @param {object} props - Component props
 * @param {string} [props.headerVariant] - Variant for the header Typography component.
 * @param {string} [props.paragraphVariant] - Variant for the paragraph Typography component.
 * @param {React.ReactNode} [props.headerChildren] - Children for the header Typography component.
 * @param {React.ReactNode} [props.paragraphChildren] - Children for the paragraph Typography component.
 * @param {string} [props.fontFamily] - Font family for both header and paragraph Typography components.
 * @param {string} [props.headerColor] - Color for header text. Should be one of: 'primary', 'secondary' or a valid CSS color string (e.g., '#FF0000').
 * @param {string} [props.paragraphColor] - Color for paragraph text. Should be one of: 'primary', 'secondary' or a valid CSS color string (e.g., '#FF0000').
 * @param {string} [props.FontWeight] - Font Weight for both header and paragraph Typography components.
 * @returns {JSX.Element} - Rendered component
 */
export default function TypographyBlock({
  headerVariant,
  paragraphVariant,
  headerChildren,
  headerwidth,
  paragraphChildren,
  headerFontFamily,
  paragraphFontFamily,
  headerColor,
  paragraphColor,
  headerFontWeight,
  paragraphFontWeight,
  paragraphwidth,
}) {
  return (
    <Box>
      {headerChildren && (
        <Box sx={{ width: headerwidth }}>
          <StyledHeader
            variant={headerVariant}
            fontFamily={headerFontFamily}
            color={headerColor}
            fontWeight={headerFontWeight}
          >
            {headerChildren}
          </StyledHeader>
        </Box>
      )}
      {paragraphChildren && (
        <div className='card-summary'>
          <Box sx={{ width: paragraphwidth }}>
            <StyledParagraph
              variant={paragraphVariant}
              fontFamily={paragraphFontFamily}
              color={paragraphColor}
              fontWeight={paragraphFontWeight}
              sx={{ pt: '20px' }}
            >
              {paragraphChildren}
            </StyledParagraph>
          </Box>
        </div>
      )}
    </Box>
  );
}

TypographyBlock.propTypes = {
  ...typographyBlockPropTypes,
};

TypographyBlock.defaultProps = {
  ...typographyBlockDefaultProps,
};
